export function appEmoji(pkg?: string, name?: string): string {
  const p = `${pkg ?? ''} ${name ?? ''}`.toLowerCase()
  if (/\b(chrome|firefox|edge|browser|opera|safari)\b/.test(p)) return '🌐'
  if (/\b(whatsapp|telegram|messenger|discord|snapchat|instagram|tiktok|wechat|line)\b/.test(p)) return '💬'
  if (/\b(youtube|twitch|netflix|prime|hbo|disney|crunchyroll)\b/.test(p)) return '🎬'
  if (/\b(spotify|music|sound|pandora|deezer)\b/.test(p)) return '🎵'
  if (/\b(roblox|minecraft|fortnite|game|league|genshin|steam|epic)\b/.test(p)) return '🎮'
  if (/\b(gmail|mail|outlook|yahoo|correo)\b/.test(p)) return '📧'
  if (/\b(camera|photo|gallery|instagram|snap)\b/.test(p)) return '📷'
  if (/\b(maps|navig|uber|cabify|waze)\b/.test(p)) return '🗺️'
  if (/\b(bank|pay|wallet|mercado|bbva|santander|cash)\b/.test(p)) return '💳'
  if (/\b(android system|system ui|settings|launcher|home)\b/.test(p)) return '⚙️'
  if (/\b(bluetooth|wifi|connect)\b/.test(p)) return '📡'
  if (/\b(calculator|clock|calendar|phone)\b/.test(p)) return '🔧'
  return '📱'
}
